import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import Input from "rsuite/Input";
import PropTypes from "prop-types";
import { envConfig, unifiedEnvConfig } from "../../constants/api-endpoint";
import { ERROR_MSG, VALIDATION } from "../../constants/app-constant";
import { httpPost } from "../../utility/requestHelper";
import { validate } from "./FormElements/Validate";
import { ShareIcon } from "../Icons/icons.component";
import { formatSocialShareArticles } from "../../utility/shareHelper";
import { groupBy, isLoggedIn } from "../../utility/common-methods";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
const DEFAULT_MAIL_TITLE = "Concept BIU Mailer Content";
const [SHARING_INPROGRESS, SHARING_SUCESS, SHARING_FAILED] = [
  "Sharing...",
  "Article shared succesfully",
  "Failed to share article",
];
const { SOCIAL_SHARE_ARTICLE, PRINT_ONLINE_SHARE_ARTICLE, TV_SHARE_ARTICLE } = envConfig;

const { FETCH_SOCIAL_FEEDS_BY_ENTITY, SHARE_ARTICLE } = unifiedEnvConfig;
export default function ShareArticle({
  article = [],
  onShareSuccess,
  isSocial,
  isBlogAndForum,
  topicType,
  isTV,
  sharePayload,
  selectedTopicIds,
  fromDate,
  toDate,
  channelType,
  selectedEntity,
  language
}) {
  const [status, setStatus] = useState("");
  const [showNamePopup, setShowNamePopup] = useState(false);
  const [subject, setSubject] = useState(undefined);
  const [email, setEmail] = useState("");
  const [enableShare, setEnableShare] = useState(true);
  const [shareClickMessage, setShareClickMessage] = useState("");
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};
  const history = useHistory();

  useEffect(() => {
    if (subject !== undefined) {
      if (subject) {
        setStatus("");
        setEnableShare(false);
      } else {
        setEnableShare(true);
        setStatus("Please provide email subject ");
      }
    }
  }, [subject]);

  useEffect(() => {
    if (email) {
      let emails = email.split(",");
      for (let e of emails) {
        if (e && validate.validateEmail(e.trim()) === ERROR_MSG.INVALID_EMAIL) {
          setEnableShare(true);
          return setStatus(
            "Enter valid email addresses separated by comma (,)"
          );
        } else {
          setStatus("");
          setEnableShare(false);
        }
      }
    }
    return () => {};
  }, [email]);

  useEffect(() => {
    if (article.length > 0) {
      setShareClickMessage("");
    }
  }, [article]);

  const share = () => {
    const client_id = selectedClient && selectedClient.id;
    if (!client_id) {
      alert("Sharing not allowed");
      return;
    }

    if (article.length == 0) {
      return setStatus("Please select one or more articles to share.");
    }
    if (!email) {
      if (validate.validateEmail(email) === ERROR_MSG.INVALID_EMAIL) {
        setStatus("Please provide a valid email address ");
      }
      return;
    }
    if (!subject) {
      setStatus("Please provide email subject ");
      return;
    }
    if (!Array.isArray(article)) {
      article = Array(article);
    }
    setStatus(SHARING_INPROGRESS);
    setEnableShare(true);
    let shareReqPromise = [];
    if (isSocial) {
      // if (isSocial) {
      //   let payload = sharePayload;
      //   payload.topic_ids = [];
      //   if (selectedTopicIds.length > 0) {
      //     [...new Set(selectedTopicIds)].forEach((t) => {
      //       payload.topic_ids.push(t);
      //     });
      //   }
      //   httpPost(FETCH_SOCIAL_FEEDS_BY_ENTITY, payload).then(({ data }) => {
      //     const reqBody = formatSocialShareArticles(data.records);
      //     shareReqPromise.push(
      //       httpPost(SHARE_ARTICLE, {
      //         is_social: 1,
      //         articles: reqBody,
      //         client_id,
      //         email_id: email,
      //         subject: subject || DEFAULT_MAIL_TITLE,
      //         rbase_url: "cbiu.weboapps.com",
      //       })
      //     );
      //   });
      // } else {
      let searchParam = {
        "to_date":toDate,
        "type":4,
        "lang":language,
        "from_date":fromDate,
        "channel_type":channelType,
        "topic_ids":selectedEntity,
        "article_ids" : article.length?article.filter(data => !selectedEntity?.includes(data.entityId)).map((data) => data.id):undefined,
        "subject":subject || DEFAULT_MAIL_TITLE, 
        "email_address":email
      }
      shareReqPromise.push(
        httpPost(SHARE_ARTICLE, {
          client_id,
          "page":1,
          "perPage":50,
          "searchParams":searchParam
        })
      );
    }
    else if (isBlogAndForum) {
      // if (isSocial) {
      //   let payload = sharePayload;
      //   payload.topic_ids = [];
      //   if (selectedTopicIds.length > 0) {
      //     [...new Set(selectedTopicIds)].forEach((t) => {
      //       payload.topic_ids.push(t);
      //     });
      //   }
      //   httpPost(FETCH_SOCIAL_FEEDS_BY_ENTITY, payload).then(({ data }) => {
      //     const reqBody = formatSocialShareArticles(data.records);
      //     shareReqPromise.push(
      //       httpPost(SHARE_ARTICLE, {
      //         is_social: 1,
      //         articles: reqBody,
      //         client_id,
      //         email_id: email,
      //         subject: subject || DEFAULT_MAIL_TITLE,
      //         rbase_url: "cbiu.weboapps.com",
      //       })
      //     );
      //   });
      // } else {
      const reqBody = formatSocialShareArticles(article);
      shareReqPromise.push(
        httpPost(PRINT_ONLINE_SHARE_ARTICLE, {

          is_social: 1,
          articles: reqBody,
          client_id,
          email_id: email,
          subject: subject || DEFAULT_MAIL_TITLE,
          rbase_url: "cbiu.weboapps.com",
        })
      );
      // }
    } else if (isTV) {
      console.log("article", article);
      const reqBody = article.map((a) => {
        const {
          headline,
          airing_date,
          electronic_id,
          channel_name,
          channel_type,
          program_name,
          duration,
          video_link,
          anchor_details,
        } = a;
        return {
          airing_date,
          electronic_id,
          channel_name,
          channel_type,
          program_name,
          duration,
          headline,
          anchors:
            (anchor_details.length &&
              anchor_details.map(({ anchor_name }) => anchor_name)) ||
            "",
          video_link,
        };
      });

      shareReqPromise.push(
        httpPost(TV_SHARE_ARTICLE, {
          articles: reqBody,
          client_id,
          email_id: email,
          subject: subject || DEFAULT_MAIL_TITLE,
          rbase_url: "cbiu.weboapps.com",
          is_social: 0,
          media_type: "electronic",
        })
      );
    } else {
      const reqBody = article.map((a) => {
        const {
          id,
          edition,
          entity_name,
          entity_id,
          entity_type,
          headline,
          language,
          publication,
          publication_type,
          publish_date,
          source,
          summary,
          article_id,
          source_name,
          link,
          page_nos,
          photo,
          images,
          imagebaseurl,
        } = a;
        return {
          article_id: article_id || id,
          edition,
          entity_id,
          entity_name,
          entity_type,
          headline,
          language,
          publication,
          publication_type,
          publish_date,
          source: source_name,
          summary,
          link,
          page_nos,
          photo,
          imagebaseurl,
          images,
        };
      });
      shareReqPromise.push(
        httpPost(PRINT_ONLINE_SHARE_ARTICLE, {
          articles: reqBody,
          client_id,
          email_id: email,
          subject: subject || DEFAULT_MAIL_TITLE,
          rbase_url: "cbiu.weboapps.com",
          is_social: 0,
          media_type: topicType,
        })
      );
    }
    Promise.allSettled(shareReqPromise)
      .then(() => {
        setStatus(SHARING_SUCESS);
        onShareSuccess();
      })
      .catch((e) => {
        setStatus(SHARING_FAILED);
      })
      .finally(() => {
        setEnableShare(false);
        setTimeout(() => {
          setShowNamePopup(false);
          setStatus("");
        }, 2000);
      });
  };
  const closeModal = () => {
    setStatus("");
    setEmail("");
  };
  const handleShareClick = () => {
    if (isLoggedIn()) {
      if (article.length == 0) {
        setShareClickMessage("Select a feed to share");
      } else {
        setShowNamePopup(true);
        setShareClickMessage("");
      }
    } else {
      history.push("/");
    }
  };

  return (
    <>
      <Modal
        onHide={() => setShowNamePopup(false)}
        show={showNamePopup}
        onExit={closeModal}
        className="customModalWrap sharePopup"
      >
        <Modal.Header closeButton>
          <Modal.Title>Share To</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <label>Subject</label>
            <Input
              id="subject"
              required
              type="text"
              value={subject}
              placeholder="Enter Subject Here"
              className="form-control"
              onChange={(s) => setSubject(s)}
            />
          </div>
          <div className="form-group">
            <label>Email</label>
            <Input
              id="email"
              required
              type="email"
              value={email}
              placeholder="Enter Email Here"
              className="form-control"
              onChange={(v) => setEmail(v.trim())}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btnWithMessage">
            <p
              className={`mr-auto text-${
                status === SHARING_INPROGRESS || status === SHARING_SUCESS
                  ? "success"
                  : "danger"
              }`}
            >
              {status}
            </p>
            <Button
              variant="default"
              onClick={() => share()}
              disabled={enableShare}
              className="btn btnBlue"
            >
              Submit
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <div className="shareBtnWrap">
        <Button onClick={() => handleShareClick()} className="shareBtn">
          <div className="hasTooltip">
            <ShareIcon />
            <span className="tooltipWrap center">Share</span>
          </div>
        </Button>
        {shareClickMessage && (
          <div className="sharedMessage">{shareClickMessage}</div>
        )}
      </div>
    </>
  );
}

ShareArticle.defaultProps = {
  article: [],
  onShareSuccess: () => {},
};

ShareArticle.prototype = {
  article: PropTypes.oneOfType(
    PropTypes.shape({}, PropTypes.arrayOf(PropTypes.shape({})))
  ),
};
